import { Controller } from 'react-hook-form';
import FormFieldContainer from '../../../../reactForm/fields/FormFieldContainer';

interface StringListFieldOptions {
    name: string;
    settings: StringListFieldSettings;
}

interface StringListFieldSettings {
    default: unknown;
    required?: boolean;
    itemLabel: string;
}

function toTextareaValue(value: unknown): string {
    if (!Array.isArray(value)) {
        return '';
    }

    return value.filter((entry): entry is string => typeof entry === 'string').join('\n');
}

function toStringListValue(value: string): string[] {
    if (!value.length) {
        return [];
    }

    return value.split('\n');
}

export default function StringListField({
    fieldOptions,
}: {
    fieldOptions: StringListFieldOptions;
}): JSX.Element {
    const { name, settings: stringListSettings } = fieldOptions;

    return (
        <Controller<Record<string, unknown>, string>
            name={name}
            defaultValue={
                Array.isArray(stringListSettings.default) ? stringListSettings.default : []
            }
            rules={{
                required: stringListSettings.required === true,
            }}
            render={({ field: { value, onChange, onBlur } }) => (
                <FormFieldContainer
                    fieldOptions={fieldOptions}
                    showOverrideCheckbox={false}
                    inline={false}
                >
                    <div className="flex flex-col gap-1">
                        <textarea
                            id={`id_${name}`}
                            value={toTextareaValue(value)}
                            onChange={(event) => onChange(toStringListValue(event.target.value))}
                            onBlur={onBlur}
                            className="min-h-[7rem] rounded border border-gray-300 px-2 py-1 font-mono text-sm"
                        />
                        <span className="text-xs text-slate-500">
                            One {stringListSettings.itemLabel} per line.
                        </span>
                    </div>
                </FormFieldContainer>
            )}
        />
    );
}
